import styled from 'styled-components';
import toRem from 'utils/toRem';
import { white } from 'constants/variables';

const LoadingSpinner = () => (
  <LoadingSpinnerContainer role="status" className="loader" />
);

const LoadingSpinnerContainer = styled.div`
  border-top: ${toRem(6)} solid rgba(255, 255, 255, 0.5);
  border-right: ${toRem(6)} solid rgba(255, 255, 255, 0.5);
  border-bottom: ${toRem(6)} solid rgba(255, 255, 255, 0.5);
  border-left: ${toRem(6)} solid ${white};
  margin-bottom: 0;
  width: 12px;
  height: 12px;
`;

export default LoadingSpinner;
